import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

const LaunchCtx = createContext(null);
export const useLaunch = () => useContext(LaunchCtx);

export function LaunchProvider({ children }) {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/config/launch");
      setEnabled(!!data.enabled);
    } catch {
      setEnabled(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <LaunchCtx.Provider value={{ enabled, loading, refresh, setEnabled }}>
      {children}
    </LaunchCtx.Provider>
  );
}
